<template>
  <div class="reservation-row-actions">
    <template v-if="isEditing">
      <md-button
        class="md-just-icon md-simple md-primary"
        @click.prevent="$emit('toggle-notes')"
      >
        <md-icon>{{
          isNotesExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</md-icon>
        <md-tooltip md-direction="top">
          {{ isNotesExpanded ? "Hide" : "Show" }} notes
        </md-tooltip>
      </md-button>
      <md-button
        class="md-just-icon md-simple md-success"
        :disabled="!canManage || actionLoading"
        @click.stop="$emit('save')"
      >
        <md-icon>check</md-icon>
        <md-tooltip md-direction="top">Save</md-tooltip>
      </md-button>
      <md-button
        class="md-just-icon md-simple"
        :disabled="!canManage || actionLoading"
        @click.stop="$emit('cancel')"
      >
        <md-icon>close</md-icon>
        <md-tooltip md-direction="top">Cancel</md-tooltip>
      </md-button>
    </template>

    <template v-else>
      <md-button
        class="md-just-icon md-simple summary-toggle"
        :class="hasNotes ? 'md-primary' : ''"
        :disabled="!hasNotes"
        @click.prevent="$emit('toggle-notes')"
      >
        <md-icon>{{
          isNotesExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</md-icon>
        <md-tooltip md-direction="top">
          {{ isNotesExpanded ? "Hide" : "Show" }} notes
        </md-tooltip>
      </md-button>
    </template>
    <md-button
      class="md-just-icon md-simple md-info"
      :disabled="!canManage || actionLoading"
      @click.stop="$emit('open-manifest')"
    >
      <md-icon>description</md-icon>
      <md-tooltip md-direction="top">Open manifest</md-tooltip>
    </md-button>
    <md-button
      class="md-just-icon md-simple md-danger"
      :disabled="!canManage || actionLoading"
      @click.stop="$emit('delete')"
    >
      <md-icon>delete</md-icon>
      <md-tooltip md-direction="top">Delete</md-tooltip>
    </md-button>
  </div>
</template>

<script>
export default {
  name: "ReservationRowActions",
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    isNotesExpanded: {
      type: Boolean,
      default: false
    },
    hasNotes: {
      type: Boolean,
      default: false
    },
    canManage: {
      type: Boolean,
      default: false
    },
    actionLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.reservation-row-actions {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.summary-toggle {
  margin: 0;
}
</style>
